import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './langs/en';
import zh from './langs/zh';
Vue.use(VueI18n);

const langs = {
  zh: Object.assign(zh, { language: '简体中文' }),
  en: Object.assign(en, { language: 'English' }),
};

if (!sessionStorage.getItem('accept_language')) {
  sessionStorage.setItem('accept_language', 'en');
}

const i18n = new VueI18n({
  locale: sessionStorage.getItem('accept_language') || 'en',
  messages: langs,
});

export { i18n };
